export enum WagonStaysArea {
    entryDateInput = 'entryDateInput',
    exitDateInput = 'exitDateInput',
    geofenceFilter = 'geofenceFilter',
    reportTable = 'reportTable',
    wagonNumberFilter = 'wagonNumberFilter',
    stateFilter = 'stateFilter',
}

export enum WagonStaysAction {
    dateRangeReset = 'dateRangeReset',
    dateRangeSet = 'dateRangeSet',
    filterClicked = 'filterClicked',
    geofenceDeselected = 'geofenceDeselected',
    geofenceNameClicked = 'geofenceNameClicked',
    geofenceReset = 'geofenceReset',
    geofenceSelected = 'geofenceSelected',
    stateSelected = 'stateSelected',
    tableFilterApplied = 'tableFilterApplied',
    tableFilterReset = 'tableFilterReset',
    tableFilterSorted = 'tableFilterSorted',
    tableResetClicked = 'tableResetClicked',
    wagonNumberClicked = 'wagonNumberClicked',
    wagonNumberDeselected = 'wagonNumberDeselected',
    wagonNumberReset = 'wagonNumberReset',
    wagonNumberSelected = 'wagonNumberSelected',
}
